import MobileDetect from 'mobile-detect';

export const md = new MobileDetect(window.navigator.userAgent);
export const deviceName = (): string => md.mobile() || 'Desktop';
export const mobileDeviceDetected = (): boolean => !!md.mobile();
export const tabletDetected = (): boolean => !!md.tablet();
export const phoneDetected = (): boolean => !!md.phone();
